import React, { useEffect, useState } from 'react';
import { ArrowLeft, CalendarClock, History, Loader2, Phone, UserRound } from 'lucide-react';
import axios from '../../configApi/axiosConfig';
import { APIURL } from '../../configApi/apiConfig';
import { formatDate } from './gestorVentasUtils';

export function GestionVentaHistorial({ oportunidad, onBack }) {
  const [state, setState] = useState({ loading: true, error: '', items: [] });

  useEffect(() => {
    let active = true;
    setState({ loading: true, error: '', items: [] });
    axios.get(APIURL.getGestorVentasHistorial(oportunidad.idOportunidad))
      .then(response => active && setState({ loading: false, error: '', items: Array.isArray(response.data) ? response.data : [] }))
      .catch(error => {
        if (!active) return;
        const message = error?.response?.data?.message;
        setState({ loading: false, error: Array.isArray(message) ? message.join(' ') : message || 'No fue posible cargar el historial.', items: [] });
      });
    return () => { active = false; };
  }, [oportunidad.idOportunidad]);

  return (
    <div className="w-full pb-1">
      <div className="flex items-center justify-between gap-3">
        <button type="button" onClick={onBack} className="inline-flex min-h-11 cursor-pointer items-center gap-2 rounded-lg px-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-morado/30">
          <ArrowLeft size={17} /> Volver a la cola
        </button>
        <span className="text-xs font-medium text-slate-600">{oportunidadLabel(oportunidad)}</span>
      </div>

      <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4">
        <div className="flex items-center gap-2"><History size={18} className="text-morado" /><h3 className="font-bold text-slate-900">Historial de {oportunidad.nombreCompleto}</h3></div>
        <p className="mt-1 text-sm text-slate-600">{oportunidad.cedula} · {oportunidad.telefono || 'Sin teléfono'}</p>
      </div>

      {state.loading && <div className="flex min-h-40 items-center justify-center gap-2 text-sm text-slate-600" role="status"><Loader2 size={18} className="animate-spin text-morado motion-reduce:animate-none" /> Cargando historial…</div>}
      {state.error && <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700" role="alert">{state.error}</div>}
      {!state.loading && !state.error && state.items.length === 0 && <div className="mt-4 rounded-xl border border-dashed border-slate-200 p-8 text-center text-sm text-slate-600">Todavía no existen gestiones registradas.</div>}

      <ol className="mt-5 space-y-4">
        {state.items.map((item, index) => (
          <li key={item.idGestionVenta} className="relative rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <p className="font-bold text-slate-900">{[item.accion, item.respuesta, item.detalle, item.clasificacion].filter(Boolean).join(' · ')}</p>
                <p className="mt-1 flex items-center gap-1.5 text-xs text-slate-600"><UserRound size={13} /> {item.usuario || 'Usuario'} · {formatDate(item.fechaGestion, true)}</p>
              </div>
              <span className="rounded-full bg-violet-100 px-2.5 py-1 text-xs font-semibold text-violet-800">Gestión {state.items.length - index}</span>
            </div>
            <dl className="mt-4 grid gap-3 text-sm sm:grid-cols-2">
              <div><dt className="text-xs font-semibold text-slate-500">Forma de atención</dt><dd className="mt-0.5 text-slate-800">{item.formasAtencion || '—'}</dd></div>
              <div><dt className="text-xs font-semibold text-slate-500">Producto interesado</dt><dd className="mt-0.5 text-slate-800">{item.productoInteresado || '—'}</dd></div>
              <div><dt className="flex items-center gap-1 text-xs font-semibold text-slate-500"><Phone size={12} /> Teléfono</dt><dd className="mt-0.5 text-slate-800">{item.telefono || '—'}</dd></div>
              <div><dt className="flex items-center gap-1 text-xs font-semibold text-slate-500"><CalendarClock size={12} /> Próxima gestión</dt><dd className="mt-0.5 text-slate-800">{formatDate(item.fechaProximaGestion)}</dd></div>
              <div className="sm:col-span-2"><dt className="text-xs font-semibold text-slate-500">Comentario</dt><dd className="mt-0.5 whitespace-pre-wrap text-slate-800">{item.comentario || '—'}</dd></div>
            </dl>
          </li>
        ))}
      </ol>
    </div>
  );
}

function oportunidadLabel(oportunidad) {
  const nivel = `Nivel ${oportunidad.prioridad || oportunidad.idNivel} · ${oportunidad.nivel || 'Nivel'}`;
  return oportunidad.subnivel
    ? `${nivel} / Subnivel ${oportunidad.prioridadSubnivel} · ${oportunidad.subnivel}`
    : nivel;
}
